import Admin from '@Pages/Admin';
import BulkSensor from '@Pages/BulkSensor';
import CreateSystemConnection from '@Pages/CreateSystemConnection';
import CreateValuemapping from '@Pages/CreateValuemapping';
import EditSensor from '@Pages/EditSensor/EditSensor';
import EditSensorData from '@Pages/EditSensorData';
import EditSystemConnection from '@Pages/EditSystemConnection';
import EditValuemapping from '@Pages/EditValuemapping';
import NewSensor from '@Pages/NewSensor/NewSensor';
import NewUserPageWithContext from '@Pages/NewUser/NewUserPageWithContext';
import { CreateSensorGroup } from '@Pages/SensorGroup';
import { UpdateLiftStation } from '@Pages/UpdateLiftStation';
import { UpdateUserPageWithContext } from '@Pages/UpdateUser';
import UploadSensorData from '@Pages/UploadSensorData';
import {
	LIFT_STATION_ROUTES,
	SENSOR_GROUP_ROUTES,
	VALUEMAPPING_ROUTES,
} from '@Types/routes';
import { addRouteNamespace } from '@Utils/actions';
import React from 'react';
import CreateLiftStation from '../pages/CreateLiftStation/CreateLiftStation';
import ManageUsersWithForm from '../pages/ManageUsers/ManageUsersWithForm';
import { UpdateSensorGroup } from '../pages/SensorGroup/UpdateSensorGroup';

export const main = [
	{
		title: 'Admin',
		to: addRouteNamespace(''),
		render: <Admin />,
		altHighlight: [
			'/admin/create-system-connection',
			'/admin/system-connection/:connectionId',
			'/admin/system-connection/:connectionId/edit',
			'/admin/create-sensor-configuration',
			'/admin/sensors/:sensorId/edit',
			'/admin/sensors/:sensorId/edit/data',
			'/admin/upload-sensor-data',
			'/admin/create-bulk-sensor',
			'/admin/create-user',
			'/admin/update-user/:auth0Id',
			'/admin/billing/users',
			'/admin/billing/simulations',
			'/admin/:subscriptionId',
			'/admin/valuemapping/profile/create',
			'/admin/valuemapping/profile/:profileId',
		],
	},
	{
		title: 'Bulk Sensor',
		to: addRouteNamespace('create-bulk-sensor'),
		render: <BulkSensor />,
	},
];

export const mainReadOnly = [
	{
		title: 'Admin',
		to: addRouteNamespace(''),
		render: <Admin />,
		altHighlight: [
			'/admin/create-sensor-configuration',
			'/admin/sensors/:sensorId/edit',
			'/admin/sensors/:sensorId/edit/data',
			'/admin/billing/users',
			'/admin/billing/simulations',
			'/admin/:subscriptionId',
			'/admin/valuemapping/profile/create',
			'/admin/valuemapping/profile/:profileId',
		],
	},
	{
		title: 'Bulk Sensor',
		to: addRouteNamespace('create-bulk-sensor'),
		render: <BulkSensor />,
	},
];

export const rootRoutes = [
	{
		title: 'DASHBOARD',
		to: '/',
		render: <Admin />,
	},
];
export const entitlements = [
	{
		title: 'Admin',
		to: addRouteNamespace('create-user'),
		render: <NewUserPageWithContext />,
	},
	{
		title: 'Update User',
		to: addRouteNamespace('update-user/:auth0Id'),
		render: <UpdateUserPageWithContext />,
	},
];

export const manageSubscriptionUsers = [
	{
		title: 'Admin',
		to: addRouteNamespace(':subscriptionId'),
		render: <ManageUsersWithForm />,
	},
];

export const sensorAndSystemConfigs = [
	{
		title: 'New Sensor Configuration',
		to: addRouteNamespace('create-sensor-configuration'),
		render: <NewSensor />,
	},
	{
		title: 'Edit Sensor Configuration',
		to: addRouteNamespace('sensors/:sensorId/edit'),
		render: <EditSensor />,
	},
	{
		title: 'Create System Connection',
		to: addRouteNamespace('create-system-connection'),
		render: <CreateSystemConnection />,
	},
	{
		title: 'Edit System Connection',
		to: addRouteNamespace('system-connection/:connectionId'),
		render: <EditSystemConnection />,
	},
];

export const sensorOnly = [
	{
		title: 'View Sensor Configuration',
		to: addRouteNamespace('sensors/:sensorId/edit'),
		render: <EditSensor />,
	},
];

export const uploadSensorDataRoutes = [
	{
		title: 'Upload Data',
		to: addRouteNamespace('upload-sensor-data'),
		render: <UploadSensorData />,
	},
];

export const billingConfigs = [];
export const editSensorData = [
	{
		title: 'Edit Sensor Data',
		to: addRouteNamespace('sensors/:sensorId/edit/data'),
		render: <EditSensorData />,
	},
];

export const valuemappingRoutes = [
	{
		title: 'Create Valuemapping',
		to: addRouteNamespace(VALUEMAPPING_ROUTES.create),
		render: <CreateValuemapping />,
	},
	{
		title: 'Edit Valuemapping',
		to: addRouteNamespace(VALUEMAPPING_ROUTES.edit),
		render: <EditValuemapping />,
	},
];

export const sensorGroupRoutes = [
	{
		title: 'Create sensor group',
		to: addRouteNamespace(SENSOR_GROUP_ROUTES.create),
		render: <CreateSensorGroup />,
	},
	{
		title: 'Update sensor group',
		to: addRouteNamespace(SENSOR_GROUP_ROUTES.edit),
		render: <UpdateSensorGroup />,
	},
];

export const liftStationsRoutes = [
	{
		title: 'Create Facility',
		to: addRouteNamespace(LIFT_STATION_ROUTES.create),
		render: <CreateLiftStation />,
	},
	{
		title: 'Update Lift Station',
		to: addRouteNamespace(LIFT_STATION_ROUTES.edit),
		render: <UpdateLiftStation />,
	},
];
